/*eslint max-lines: ["error", 600]*/

/**
 *  Module for register Hook
 */

const RegisterHook = function (app) {

  /**
   *  Private Properties/Methods
   */
  const configure = app.configure,
    $ = require('jquery'),
    _ = require('lodash');
  let sharedStyleNumber;
  const generateImageUrl = require('./generateImageUrl')(app);
  app.generateImageUrl = generateImageUrl;

  /* ============================================
  =            After Hook Functions             =
  ============================================ */
  function getExtraInfoHtml(av, metadata) {
    const afterHookLabel = metadata.after_hook_label;
    const linkLabel = app.l10n.getLang(metadata.after_hook_label, 'Extra Details');
    const markup = '<div class="fc-' + afterHookLabel + '" tabindex="0">' + linkLabel + '</div>';
    return markup;
  }
  function addClickEvent(id, selectedValueName, functionName) {
    _.defer(function () {
      if (selectedValueName === 'style_number') {
        selectedValueName = sharedStyleNumber;
      }
      $('.fc-' + id).attr('role', 'link');
      $('.fc-' + id).off('click').on('click', function () {
        window[functionName](selectedValueName);
      });
      $('.fc-' + id).off('keypress').on('keypress', function (e) {
        if (e.key !== 'Enter') { return; }
        window[functionName](selectedValueName);
      });
    });
  }
  let skuElementCreated = false;
  let styleNumberElementCreated = false;
  function createElement(className) {
    const markup = '<span class="' + className + '"></span>';
    $('.fc-attribute-selector-alias-style h3').append(markup);
    $('.fc-attribute-selector-alias-style h4').append(markup);
  }
  const skuClassName = 'fc-attribute-header-sku';
  function updateSkuElement() {
    const sku = app.helpers.getSelectedValueByAlias('oms_sku');
    if (!sku) {
      return;
    }
    if (!skuElementCreated) {
      skuElementCreated = true;
      createElement(skuClassName);
    }
    $('.' + skuClassName).html('Sku Number ' + sku.vendorId);
  }

  const styleClassName = 'fc-attribute-header-style-number';
  function updateStyleNumberElement() {
    const styleNumber = app.helpers.getFacetsByAlias('oms_sku')['style_#'];
    if (!styleNumberElementCreated) {
      styleNumberElementCreated = true;
      createElement(styleClassName);
    }
    sharedStyleNumber = styleNumber ? styleNumber.name : '';
    let suffix = '';
    if (sharedStyleNumber !== '') {
      suffix += ' #' + sharedStyleNumber;
    }
    $('.' + styleClassName).html(suffix);
  }
  function updateSkuAndStyleElements(changes) {
    const styleNumberAlias = ['style', 'fit', 'fabric'];
    const skuAlias = ['color', 'size'];
    const styleChange = _.find(changes, function (o) {
      return styleNumberAlias.indexOf(o.ca.alias) !== -1;
    });
    const skuChange = _.find(changes, function (o) {
      return skuAlias.indexOf(o.ca.alias) !== -1;
    });
    if (styleChange || !/#\d+/.test($(`.${styleClassName}`).text())) {
      _.defer(updateStyleNumberElement);
    }
    if (skuChange || !/Sku Number \d+/.test($(`.${skuClassName}`).text())) {
      _.defer(updateSkuElement);
    }
  }
  function updateGlobalLinks(selected, attr) {
    if (selected && selected.metadata) {
      const metadata = app.utils.getMetaData(selected);
      addClickEvent(metadata.after_hook_label, 'style_number', metadata.after_hook_callback);
    } else if (attr.alias === 'style') {
      // fit depends on the style selected, if the user is changing the style, we need to update the Fit link.
      const fitSelected = app.helpers.getSelectedValueByAlias('fit');
      if (fitSelected && fitSelected.metadata) {
        const fitMetadata = app.utils.getMetaData(fitSelected);
        addClickEvent(fitMetadata.after_hook_label, 'style_number', fitMetadata.after_hook_callback);
      }
    } else {
      attr.subAttributes.map(function (attribute) {
        return attribute.values.map(function (value) {
          if (value.metadata && value.selected) {
            const metadata = app.utils.getMetaData(value);
            if (metadata.after_hook_label) {
              addClickEvent(metadata.after_hook_label, 'style_number', metadata.after_hook_callback);
            }
          }
        });
      });
    }
  }

  const fcOptionalClassName = 'fc-panel-description-optional';
  const addOptionalTextToHeaders = (ca) => {
    if (ca.selectorClass === 'fc-optional-accordion-header') {
      const optionalLabel = app.l10n.getLang('optional_label', 'Optional');
      return '<span class="' + fcOptionalClassName + '">(' + optionalLabel + ')</span>';
    }
  };
  /* =====  End of After Hook Functions  ====== */
  /* =========================================
  =            Swatches UpCharge             =
  ========================================= */
  const INITIALS_UPCHARGE_ALIAS = 'upcharge_initials';
  const getInitialsUpcharge = () => {
    if (app.helpers.hasAttribute(INITIALS_UPCHARGE_ALIAS)) {
      const initials = configure.run('getAttribute', { alias: INITIALS_UPCHARGE_ALIAS });
      const yesValue = initials.values.find(val => val.vendorId === 'Yes');
      return yesValue && yesValue.upcharge;
    }
  };

  const ALLOWED_UPCHARGES_ALIASES = [
    'left_chest',
    'right_chest',
    'right_hem',
    'name_on_back',
    'number_on_back',
    'hat_front',
    'hat_back',
    'customize_back',
    'customize_front',
    'back_top',
    'names_and_monograms',
    'monogram_type',
    'logo_type'
  ];
  const INITIALS_UPCHARGE_AVS = ['center_pony'];
  const appendUpcharge = (av, alias) => {
    const result = JSON.parse(JSON.stringify(av));
    if (ALLOWED_UPCHARGES_ALIASES.includes(alias)) {
      const upchargeOptions = { precision: 0 };
      if (configure.run('getCurrency') === 'EUR') {
        upchargeOptions.format = { pos: '%v%s' };
      }
      let upcharge = av.upcharge ? ` +${configure.run('formatPrice', av.upcharge, upchargeOptions)}` : '';

      // Add upcharge range for initials upcharge
      if (INITIALS_UPCHARGE_AVS.includes(av.vendorId)) {
        const initialsUpcharge = getInitialsUpcharge();
        if (initialsUpcharge) {
          upcharge += `-${configure.run('formatPrice', av.upcharge + initialsUpcharge, upchargeOptions)}`;
        }
      }

      result.name = result.name + upcharge;
    }
    return result;
  };

  /* =====  End of Swatches UpCharge  ====== */
  const swatchesHooks = (av, alias) => {
    let result = appendUpcharge(av, alias);
    if (app.appUtils.isDTGProduct()) {
      result = generateImageUrl.getSwatchUrl(result, alias);
    }
    return result;
  };

  /* ===== Customize It hook ===== */

  function createCustomizeHook() {
    const customizeItClass = 'fc-customize-it-hook';
    const customizeItAlias = 'customize_selection';

    if (!app.helpers.hasAttribute(customizeItAlias)) {
      return;
    }

    const customizeHtml = function () {
      return `<div class="${customizeItClass} fc-outline-target" role="button" aria-pressed="false" tabindex="0"></div>`;
    };
    configure.run('registerHook', `component.attributeHeader.beforeHtml.${customizeItAlias}`, customizeHtml);

    const statusClass = (value) => {
      return `fc-customize-status-${value.toLowerCase()}`;
    };

    _.defer(function () {
      const customizeButton = $(`.${customizeItClass}`);
      const status = app.helpers.getSelectedValueByAlias(customizeItAlias).vendorId;
      customizeButton.closest('.fc-attribute-selector-custom-after-html-hook').addClass(`${customizeItClass}-wrapper`);
      customizeButton.addClass(statusClass(status));

      const toggleEvent = () => {
        const status = app.helpers.getSelectedValueByAlias(customizeItAlias).vendorId;
        customizeButton.removeClass(statusClass(status));
        const newStatus = status === 'Yes' ? 'No' : 'Yes';
        configure.run('selectValue', { ca: customizeItAlias, av: { vendorId: newStatus } }, (err) => {
          app._callback(err);
          customizeButton.addClass(statusClass(newStatus));
          const isActive = newStatus === 'Yes';
          customizeButton.attr('aria-pressed', isActive);

          const index = isActive ? 2 : 0;
          app.menu.component().trigger('attributeList:setIndex', index);

          const attr = app.getRenderableAttributes()[index];
          if (attr.viewName && app.store.currentView() !== attr.viewName) {
            app.actions.updateView(attr.viewName);
          }

          const firstInteractiveParent = $(`.fc-attribute-selector-alias-${attr.alias}`);
          const outlineTarget = firstInteractiveParent.find('.fc-outline-target');
          if (outlineTarget.length) {
            outlineTarget[0].focus();
          }
        });
      };

      const customizeHeader = $('.fc-accordion-panel-ca-customize_selection .fc-accordion-panel-header');
      customizeHeader.off('click').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleEvent();

        const status = app.helpers.getSelectedValueByAlias(customizeItAlias).vendorId;

        app.appUtils.setFieldsVisibility(status);
      });
      customizeHeader.off('keydown').on('keydown', function (e) {
        // alt often used as modifier key in assistive tools
        // we don't want to intercept those
        if (e.altKey) {
          return;
        }

        switch (e.keyCode) {
          case 32: //space
          case 13: //enter
            e.preventDefault();
            toggleEvent();
            break;

          default:
            break;
        }
      });
    });
  }

  /* ===== End of Customize It ===== */

  function init() {
    if (app.appUtils.isDTGProduct()) {
      configure.run(
        'registerHook',
        'method.generateImageUrl',
        generateImageUrl.getViewUrl
      );
    } else if (app.appUtils.isNonClothingProduct()) {
      configure.run(
        'registerHook',
        'method.generateImageUrl',
        generateImageUrl.getNonProductViewUrl);
    }
    // We are disabling all this hooks for Direct to Garment.
    const allowedDescriptionAlias = ['hat_front', 'left_chest'];
    const allowedUpchargeAlias = ['center_chest_monogram'];
    const allowedCustomizeItAlias = ['hat_front_customization_selection', 'left_chest_customization_selection'];
    const allowedHowToMonogramAlias = [
      { alias: 'left_chest_monogram', parent: 'left_chest' },
      { alias: 'right_hem_monogram', parent: 'right_hem' },
      { alias: 'hat_front_monogram', parent: 'hat_front' },
      { alias: 'hat_back_monogram', parent: 'hat_back' }
    ];
    const customizeIt = app.l10n.getLang('customize_it_flag', 'Customize It');
    configure.run('registerHook', 'component.attributeSelector.beforeHtml', function (ca) {
      let markup = '<div>';
      if (app.appUtils.isDTGProduct()) {
        if (ca.alias === 'customize_front') {
          const chooseCollectionText = app.l10n.getLang('choose_graphic_collection_text', 'Choose a graphic collection');
          markup += `<div class="fc-choose-collection">${chooseCollectionText}</div>`;
        }
      }
      if (allowedDescriptionAlias.indexOf(ca.alias) !== -1) {
        markup += '<div class="fc-description">' + ca.description + '</div>';
      }
      if (allowedUpchargeAlias.includes(ca.alias)) {
        const initialsUpcharge = getInitialsUpcharge();
        if (initialsUpcharge) {
          const upchargeOptions = { precision: 0 };
          if (configure.run('getCurrency') === 'EUR') {
            upchargeOptions.format = { pos: '%v%s' };
          }
          markup += `<div class="fc-initials-upcharge">(+${configure.run('formatPrice', initialsUpcharge, upchargeOptions)})</div>`;
        }
      }
      if (allowedCustomizeItAlias.includes(ca.alias)) {
        markup += '<div class="fc-customize-it">' + customizeIt + '</div>';
      }

      switch (ca.alias) {
        case 'right_chest':
          // Flag section.
          const flagsInstructions = app.l10n.getLang('flags_instructions', 'Available only with classic pony, big pony, or dual pony selection at left chest.');
          markup += '<div class="fc-before-html-hook-description">' + flagsInstructions + '</div>';
          break;

        case 'names_and_monograms':
          markup += `<div class="fc-description">${app.l10n.getLang('pick_placement_flag', 'Pick a Placement')}</div>`;
          break;

        case 'name_only_customization_selection':
        case 'name_and_date_customization_selection':
        case 'center_customization_selection':
        case 'corner_customization_selection':
          markup += `<div class="fc-description">${app.l10n.getLang('pick_font_flag', 'Pick a Font')}</div>`;
          break;
      }

      _.forEach(allowedHowToMonogramAlias, (data) => {
        if (data.alias === ca.alias && !app.appUtils.isJapan()) {
          const alias = data.parent;
          const selectedValue = app.helpers.getSelectedValueByAlias(alias);
          const metadata = selectedValue && selectedValue.metadata ? app.utils.getMetaData(selectedValue) : '';
          if (metadata && metadata.after_hook_label) {
            markup += getExtraInfoHtml(ca, metadata, selectedValue);
          }
        }
      });

      markup += '</div>';
      return markup;
    });
    configure.run('registerHook', 'component.attributeSelector.swatch', swatchesHooks);
    configure.run('registerHook', 'component.attributeSelector.button', appendUpcharge);

    configure.run('registerHook', 'component.attributeHeader.afterHtml', addOptionalTextToHeaders);
    if (!app.utils.isMobile()) {
      createCustomizeHook();
    }
  }

  /**
   *  Expose Public Properties/Methods
   */
  return {
    init,
    updateGlobalLinks,
    updateSkuAndStyleElements,
    updateStyleNumberElement,
    updateSkuElement,
    skuElementCreated,
    styleNumberElementCreated,
    swatchesHooks
  };
};

module.exports = RegisterHook;
